import React from 'react';
import {createSvgIcon} from '../create-svg-icon';

export const SignalCellular2BarIcon = createSvgIcon(
  <React.Fragment>
    <path fillOpacity=".3" d="M2 22h20V2L2 22z" />
    <path d="M14 10L2 22h12V10z" />
  </React.Fragment>,
  'SignalCellular2BarOutlined'
);
